import React, { useState, useEffect, useRef } from "react";
import { format, parseISO } from "date-fns";
import { getConfig } from "../helpers/auth-helper";
import { getSrcPath } from "../helpers/auth-helper";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
let process = {
  env: {}
};
const History = () => {
  var _showBitDetails$heade, _showBitDetails$heade2, _showBitDetails$loyal, _showBitDetails$heade3, _showBitDetails$payme, _showBitDetails$payme2;
  const headerConfig = getConfig();
  const hostSrc = getSrcPath();
  const [activehistoryType, setActiveIndex] = useState(0);
  const [memberTransactions, setMemberTransactions] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [nextUrl, setNextUrl] = useState(null);
  // let memberData = JSON.parse(localStorage.getItem("memberData"));
  let memberId = localStorage.getItem("memberId");
  let jwtToken = localStorage.getItem("jwtToken");
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [showBitDetailsPopup, setShowBitDetailsPopup] = useState(false);
  const [showBitDetails, setShowBitDetails] = useState('');
  const [rewardPointsBreakup, setRewardPointsBreakup] = useState('');
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    scrollToTop();
    // bitDetailsPopupOpen(true,'')
  }, []);
  useEffect(() => {
    if (showBitDetailsPopup) {
      document.body.classList.add('no-history-container-scroll');
    } else {
      document.body.classList.remove('no-history-container-scroll');
    }
  }, [showBitDetailsPopup]);
  const tabRefs = useRef([]);
  const handleClickScroll = index => {
    var _tabRefs$current$inde;
    toggleFilter(index);
    // Scroll to the clicked tab
    (_tabRefs$current$inde = tabRefs.current[index]) === null || _tabRefs$current$inde === void 0 || _tabRefs$current$inde.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: index === 0 ? 'start' : 'center' // scroll to start for 1st tab, center for others
    });
  };
  const bitDetailsPopupOpen = async (flag, bitData) => {
    if (flag == true) {
      let rewardData = '';
      const url = hostSrc + "/bolapi/v1/bits/".concat(bitData.id, "/accruals/?ordering=-id&page_size=20/");
      const headers = headerConfig;
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: headers
        });
        rewardData = await response.json();
      } catch (error) {
        console.error("Error:", error);
      }
      let rewardPointsOffers = bitData.offer_actions.filter(offer => offer.type === "REWARD_POINTS");
      rewardData.forEach(item1 => {
        const match = rewardPointsOffers.find(item2 => {
          var _item2$reward_tags, _item1$reward_tags;
          return parseInt(item2.offer_id) === item1.offer_id && ((_item2$reward_tags = item2.reward_tags) === null || _item2$reward_tags === void 0 ? void 0 : _item2$reward_tags[0]) === ((_item1$reward_tags = item1.reward_tags) === null || _item1$reward_tags === void 0 ? void 0 : _item1$reward_tags[0]);
        });
        if (match) {
          match.expiration_date = item1.expiration_date;
        }
      });
      setRewardPointsBreakup(rewardPointsOffers);
    }
    setShowBitDetailsPopup(flag);
    setShowBitDetails(bitData);
  };
  const toggleFilter = index => {
    setSkeletonLoading(true);
    setActiveIndex(index);
    if (index == 0) {
      getPointsHistory({
        bitType: "PURCHASE,PAYMENT_WITH_POINTS,REVERSAL,ENROL,EXPIRATION,THIRD_PARTY_REWARD,QRCODE_REWARD"
      });
      scrollToTop();
    } else if (index == 1) {
      getPointsHistory({
        bitType: "PURCHASE,ENROL,THIRD_PARTY_REWARD,QRCODE_REWARD"
      });
      scrollToTop();
    } else if (index == 2) {
      getPointsHistory({
        bitType: "PAYMENT_WITH_POINTS"
      });
      scrollToTop();
    } else if (index == 3) {
      getPointsHistory({
        bitType: "REVERSAL"
      });
      scrollToTop();
    } else {
      getPointsHistory({
        bitCategory: "EXPIRATION"
      });
      scrollToTop();
    }
  };
  const getPointsHistory = async params => {
    let bitTypeParam = "";
    if (params.bitType && params.bitType != "all") {
      bitTypeParam = "&bit_type=".concat(params.bitType);
    }
    let bitCategoryParam = "";
    if (params.bitCategory) {
      bitCategoryParam = "&bit_category=".concat(params.bitCategory);
    }
    const url = hostSrc + "/bolapi/v1/bits/?member_id=".concat(memberId, "&page_size=").concat(pageSize, "&points_only=Y&status=SUCCESS").concat(bitCategoryParam).concat(bitTypeParam);
    const headers = headerConfig;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });
      setNextUrl(response.headers.get("Next"));
      let filteredData = await response.json();
      if (url.includes("bit_type=PURCHASE,ENROL,REVERSAL,THIRD_PARTY_REWARD")) {
        filteredData = filteredData.filter(item => {
          var _item$loyalty_balance;
          return (item === null || item === void 0 || (_item$loyalty_balance = item.loyalty_balances) === null || _item$loyalty_balance === void 0 || (_item$loyalty_balance = _item$loyalty_balance[0]) === null || _item$loyalty_balance === void 0 ? void 0 : _item$loyalty_balance.redeemed) === 0;
        });
      }
      if (url.includes("bit_type=PAYMENT_WITH_POINTS")) {
        filteredData = filteredData.filter(item => {
          var _item$loyalty_balance2;
          return (item === null || item === void 0 || (_item$loyalty_balance2 = item.loyalty_balances) === null || _item$loyalty_balance2 === void 0 || (_item$loyalty_balance2 = _item$loyalty_balance2[0]) === null || _item$loyalty_balance2 === void 0 ? void 0 : _item$loyalty_balance2.rewarded) === 0;
        });
      }
      let bitsSeperatedByDates = getBitsAccordingToMonth(filteredData);
      setMemberTransactions(bitsSeperatedByDates);
      setSkeletonLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const nextCall = async nexturl => {
    const url = nexturl;
    const headers = headerConfig;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });
      setNextUrl(response.headers.get("Next"));
      let filteredData = await response.json();
      if (url.includes("bit_type=PURCHASE%2CENROL%2CREVERSAL%2CTHIRD_PARTY_REWARD")) {
        filteredData = filteredData.filter(item => {
          var _item$loyalty_balance3;
          return (item === null || item === void 0 || (_item$loyalty_balance3 = item.loyalty_balances) === null || _item$loyalty_balance3 === void 0 || (_item$loyalty_balance3 = _item$loyalty_balance3[0]) === null || _item$loyalty_balance3 === void 0 ? void 0 : _item$loyalty_balance3.redeemed) === 0;
        });
      }
      if (url.includes("bit_type=PAYMENT_WITH_POINTS")) {
        filteredData = filteredData.filter(item => {
          var _item$loyalty_balance4;
          return (item === null || item === void 0 || (_item$loyalty_balance4 = item.loyalty_balances) === null || _item$loyalty_balance4 === void 0 || (_item$loyalty_balance4 = _item$loyalty_balance4[0]) === null || _item$loyalty_balance4 === void 0 ? void 0 : _item$loyalty_balance4.rewarded) === 0;
        });
      }
      let bitsSeperatedByDates = getBitsAccordingToMonth(filteredData);
      let arrayConverted = Object.values([...memberTransactions, ...bitsSeperatedByDates].reduce((acc, item) => {
        const {
          month,
          bitsArray
        } = item;
        if (!acc[month]) {
          acc[month] = {
            month,
            bitsArray: []
          };
        }
        acc[month].bitsArray = [...new Set([...acc[month].bitsArray, ...bitsArray])];
        return acc;
      }, {}));
      setMemberTransactions(arrayConverted);
      setSkeletonLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    getPointsHistory({
      bitType: "PURCHASE,PAYMENT_WITH_POINTS,REVERSAL,ENROL,EXPIRATION,THIRD_PARTY_REWARD,QRCODE_REWARD"
    });
  }, []);
  function getBitsAccordingToMonth(data) {
    let dateBitsData = new Map();
    data.forEach(bits => {
      let parsedDate = parseISO(bits.h_bit_date);
      let memberTillreadableDate = "";
      memberTillreadableDate = format(parsedDate, "MMMM yyyy");
      let month = memberTillreadableDate;
      if (!dateBitsData.has(month)) {
        dateBitsData.set(month, []);
      }
      let monthBitsValue = dateBitsData.get(month);
      monthBitsValue.push(bits);
    });
    let arrayFromOfMonthBits = [];
    for (const [key, value] of dateBitsData.entries()) {
      let monthObj = {};
      monthObj.month = key;
      monthObj.bitsArray = value;
      arrayFromOfMonthBits.push(monthObj);
    }
    sortByMonth(arrayFromOfMonthBits);
    return arrayFromOfMonthBits;
  }
  function sortByMonth(arr) {
    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    arr.sort(function (a, b) {
      let [aMonth, aYear] = a.month.split(" ");
      let [bMonth, bYear] = b.month.split(" ");
      if (aYear !== bYear) {
        return parseInt(bYear) - parseInt(aYear);
      }
      return months.indexOf(bMonth) - months.indexOf(aMonth);
    });
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "history-container ".concat(showBitDetailsPopup ? 'disabled' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "history-tab-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "history-heading"
  }, "Points history "), /*#__PURE__*/React.createElement("div", {
    className: "tab-container"
  }, ['all', 'earned', 'redeemed', 'cancelled', 'expired'].map((label, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    ref: el => tabRefs.current[index] = el,
    className: activehistoryType === index ? "tab selected-tab" : "tab",
    onClick: () => handleClickScroll(index)
  }, label)))), skeletonLoading ? /*#__PURE__*/React.createElement("div", {
    style: {
      width: "350px",
      margin: "auto",
      padding: "20px 0"
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 60,
    width: 350,
    borderRadius: 10,
    count: 10,
    style: {
      opacity: "0.2",
      marginBottom: "10px"
    }
  })) : memberTransactions.length > 0 ? /*#__PURE__*/React.createElement("div", null, memberTransactions.map(memberBits => /*#__PURE__*/React.createElement("div", {
    className: "table-history-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "date-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "date"
  }, memberBits.month), /*#__PURE__*/React.createElement("div", {
    className: "date"
  }, memberBits === null || memberBits === void 0 ? void 0 : memberBits.bitsArray.length, " Transactions")), /*#__PURE__*/React.createElement("div", {
    className: "table-container"
  }, memberBits.bitsArray.map(bitsArrayValue => {
    var _bitsArrayValue$loyal, _bitsArrayValue$loyal2, _bitsArrayValue$loyal3, _bitsArrayValue$loyal4;
    return /*#__PURE__*/React.createElement("div", {
      className: "table-items",
      onClick: () => {
        if ((bitsArrayValue === null || bitsArrayValue === void 0 ? void 0 : bitsArrayValue.h_bit_type) === "THIRD_PARTY_REWARD" || (bitsArrayValue === null || bitsArrayValue === void 0 ? void 0 : bitsArrayValue.h_bit_type) === "PURCHASE" || (bitsArrayValue === null || bitsArrayValue === void 0 ? void 0 : bitsArrayValue.h_bit_type) === "ENROL") {
          bitDetailsPopupOpen(true, bitsArrayValue);
        }
      }
    }, (bitsArrayValue === null || bitsArrayValue === void 0 ? void 0 : bitsArrayValue.loyalty_balances) != null ? /*#__PURE__*/React.createElement("div", {
      className: "details",
      key: bitsArrayValue.id
    }, /*#__PURE__*/React.createElement("img", {
      className: "points-logo",
      src: bitsArrayValue ? bitsArrayValue === null || bitsArrayValue === void 0 ? void 0 : bitsArrayValue.sponsor_logo : ""
    }), /*#__PURE__*/React.createElement("div", {
      className: "retail-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "retail-name"
    }, bitsArrayValue ? bitsArrayValue === null || bitsArrayValue === void 0 ? void 0 : bitsArrayValue.sponsor_name : "", " "), /*#__PURE__*/React.createElement("div", {
      className: "points-valid"
    }, bitsArrayValue !== null && bitsArrayValue !== void 0 && bitsArrayValue.h_bit_source_generated_id ? "".concat(bitsArrayValue === null || bitsArrayValue === void 0 ? void 0 : bitsArrayValue.h_bit_source_generated_id, "\u30FB").concat(new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).format(new Date(bitsArrayValue === null || bitsArrayValue === void 0 ? void 0 : bitsArrayValue.h_bit_date))) : "")), /*#__PURE__*/React.createElement("div", {
      className: "points-gained"
    }, /*#__PURE__*/React.createElement("div", {
      className: "points-plus"
    }, bitsArrayValue && bitsArrayValue !== null && bitsArrayValue !== void 0 && (_bitsArrayValue$loyal = bitsArrayValue.loyalty_balances) !== null && _bitsArrayValue$loyal !== void 0 && (_bitsArrayValue$loyal = _bitsArrayValue$loyal[0]) !== null && _bitsArrayValue$loyal !== void 0 && _bitsArrayValue$loyal.rewarded ? "+".concat(bitsArrayValue === null || bitsArrayValue === void 0 || (_bitsArrayValue$loyal2 = bitsArrayValue.loyalty_balances) === null || _bitsArrayValue$loyal2 === void 0 || (_bitsArrayValue$loyal2 = _bitsArrayValue$loyal2[0]) === null || _bitsArrayValue$loyal2 === void 0 ? void 0 : _bitsArrayValue$loyal2.rewarded) : ""), /*#__PURE__*/React.createElement("div", {
      className: "points-plus",
      style: {
        color: "white"
      }
    }, bitsArrayValue && bitsArrayValue !== null && bitsArrayValue !== void 0 && (_bitsArrayValue$loyal3 = bitsArrayValue.loyalty_balances) !== null && _bitsArrayValue$loyal3 !== void 0 && (_bitsArrayValue$loyal3 = _bitsArrayValue$loyal3[0]) !== null && _bitsArrayValue$loyal3 !== void 0 && _bitsArrayValue$loyal3.redeemed ? "-".concat(bitsArrayValue === null || bitsArrayValue === void 0 || (_bitsArrayValue$loyal4 = bitsArrayValue.loyalty_balances) === null || _bitsArrayValue$loyal4 === void 0 || (_bitsArrayValue$loyal4 = _bitsArrayValue$loyal4[0]) === null || _bitsArrayValue$loyal4 === void 0 ? void 0 : _bitsArrayValue$loyal4.redeemed) : ""), /*#__PURE__*/React.createElement("div", {
      className: "points-expiry"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "details",
      key: bitsArrayValue.id
    }, /*#__PURE__*/React.createElement("img", {
      className: "points-logo",
      src: bitsArrayValue ? bitsArrayValue === null || bitsArrayValue === void 0 ? void 0 : bitsArrayValue.sponsor_logo : ""
    }), /*#__PURE__*/React.createElement("div", {
      className: "retail-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "retail-name"
    }, bitsArrayValue ? bitsArrayValue === null || bitsArrayValue === void 0 ? void 0 : bitsArrayValue.sponsor_name : "", " "), /*#__PURE__*/React.createElement("div", {
      className: "points-valid"
    }, bitsArrayValue !== null && bitsArrayValue !== void 0 && bitsArrayValue.h_bit_source_generated_id ? "".concat(bitsArrayValue === null || bitsArrayValue === void 0 ? void 0 : bitsArrayValue.h_bit_source_generated_id, "\u30FB").concat(new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).format(new Date(bitsArrayValue === null || bitsArrayValue === void 0 ? void 0 : bitsArrayValue.h_bit_date))) : "")), /*#__PURE__*/React.createElement("div", {
      className: "points-gained"
    }, /*#__PURE__*/React.createElement("div", {
      className: "points-plus"
    }))));
  })))), nextUrl && nextUrl != "None" && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "fit-content",
      margin: "auto",
      cursor: "pointer",
      color: "#F1CA83",
      opacity: "1",
      lineHeight: "40px",
      borderRadius: "20px",
      fontWeight: "600",
      padding: "0 20px",
      letterSpacing: "0.5px"
    },
    onClick: () => nextCall(nextUrl)
  }, "View More Transactions", /*#__PURE__*/React.createElement("img", {
    style: {
      transform: "rotate(90deg)",
      width: "20px",
      marginLeft: "5px"
    },
    className: "transactions-logo",
    src: "https://d3hc1c528irei0.cloudfront.net/ui/rightarrow.png"
  })))) : /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "200px 0px 500px",
      width: "165px",
      margin: "auto"
    }
  }, "No transactions found") // Safe fallback content
  ), showBitDetailsPopup ? /*#__PURE__*/React.createElement("div", {
    className: "bit-details-popup"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bit-details-heading-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bit-details-heading"
  }, "Transaction Details"), /*#__PURE__*/React.createElement("div", {
    className: "bit-details-close",
    onClick: () => bitDetailsPopupOpen(false)
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://d3hc1c528irei0.cloudfront.net/ui/cross.png"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "bit-details-heading-container-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bit-details-logo-id"
  }, showBitDetails !== null && showBitDetails !== void 0 && showBitDetails.sponsor_logo ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: showBitDetails === null || showBitDetails === void 0 ? void 0 : showBitDetails.sponsor_logo
  })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: "https://images.ctfassets.net/vel1ejdzohgb/64g3zfuR587gKnOBaDqsIa/707049495ec9d2760edd1c41fecdaf80/BLRPulseLogo.png"
  })), showBitDetails !== null && showBitDetails !== void 0 && showBitDetails.sponsor_name ? /*#__PURE__*/React.createElement("div", {
    style: {
      width: "155px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  }, showBitDetails === null || showBitDetails === void 0 ? void 0 : showBitDetails.sponsor_name) : /*#__PURE__*/React.createElement("div", null, "BLR Pulse App")), /*#__PURE__*/React.createElement("div", {
    className: "bit-details-name-date"
  }, /*#__PURE__*/React.createElement("div", null, (() => {
    const date = new Date(showBitDetails === null || showBitDetails === void 0 ? void 0 : showBitDetails.h_bit_date);
    const daySuffix = day => {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };
    const day = date.getDate();
    return "".concat(date.toLocaleString('en-GB', {
      weekday: 'short'
    }), ", ").concat(day).concat(daySuffix(day), " ").concat(date.toLocaleString('en-GB', {
      month: 'short'
    }), " ").concat(date.getFullYear(), ". ").concat(date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit'
    }));
  })()), showBitDetails !== null && showBitDetails !== void 0 && (_showBitDetails$heade = showBitDetails.header) !== null && _showBitDetails$heade !== void 0 && _showBitDetails$heade.h_bit_source_generated_id ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex"
    }
  }, "Transaction ID:\xA0", /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: "600"
    }
  }, showBitDetails === null || showBitDetails === void 0 || (_showBitDetails$heade2 = showBitDetails.header) === null || _showBitDetails$heade2 === void 0 ? void 0 : _showBitDetails$heade2.h_bit_source_generated_id)) : /*#__PURE__*/React.createElement(React.Fragment, null))), /*#__PURE__*/React.createElement("div", {
    className: "bit-details-transactions-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bit-details-total-points"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "5px"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://d3hc1c528irei0.cloudfront.net/ui/EarningCoins/PulseCoin.png",
    style: {
      height: "24px"
    }
  }), "Total Points Earned"), /*#__PURE__*/React.createElement("div", null, "+", showBitDetails === null || showBitDetails === void 0 || (_showBitDetails$loyal = showBitDetails.loyalty_balances) === null || _showBitDetails$loyal === void 0 || (_showBitDetails$loyal = _showBitDetails$loyal[0]) === null || _showBitDetails$loyal === void 0 ? void 0 : _showBitDetails$loyal.rewarded)), /*#__PURE__*/React.createElement("div", {
    className: "bit-details-points-breakup-container"
  }, rewardPointsBreakup.map((item, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, /*#__PURE__*/React.createElement("div", {
    className: "bit-details-points-breakup"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bit-details-points-breakup-1"
  }, /*#__PURE__*/React.createElement("img", {
    src: item !== null && item !== void 0 && item.offer_mobile_image ? item === null || item === void 0 ? void 0 : item.offer_mobile_image : showBitDetails === null || showBitDetails === void 0 ? void 0 : showBitDetails.sponsor_logo
  })), /*#__PURE__*/React.createElement("div", {
    className: "bit-details-points-breakup-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bit-details-points-breakup-21"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bit-details-points-breakup-211"
  }, item === null || item === void 0 ? void 0 : item.offer_name), /*#__PURE__*/React.createElement("div", {
    className: "bit-details-points-breakup-212"
  }, "Valid until: ", new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }).format(new Date(item === null || item === void 0 ? void 0 : item.expiration_date)))), /*#__PURE__*/React.createElement("div", {
    className: "bit-details-points-breakup-22"
  }, "+", item === null || item === void 0 ? void 0 : item.value_n))), index < rewardPointsBreakup.length - 1 && /*#__PURE__*/React.createElement("div", {
    className: "divider-line"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "bit-details-general"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bit-details-general-columns"
  }, /*#__PURE__*/React.createElement("div", null, "Transaction Type"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: "500"
    }
  }, (showBitDetails === null || showBitDetails === void 0 ? void 0 : showBitDetails.h_bit_type) === 'PURCHASE' ? 'Shopping' : (showBitDetails === null || showBitDetails === void 0 ? void 0 : showBitDetails.h_bit_type) === 'ENROL' ? 'Enrolment' : 'Referral')), showBitDetails !== null && showBitDetails !== void 0 && (_showBitDetails$heade3 = showBitDetails.header) !== null && _showBitDetails$heade3 !== void 0 && _showBitDetails$heade3.h_bit_source_generated_id ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bit-details-general-columns"
  }, /*#__PURE__*/React.createElement("div", null, "Transaction Value"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: "500"
    }
  }, "\u20B9", showBitDetails === null || showBitDetails === void 0 ? void 0 : showBitDetails.h_bit_amount)), /*#__PURE__*/React.createElement("div", {
    className: "bit-details-general-columns"
  }, /*#__PURE__*/React.createElement("div", null, "Points redeemed"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: "500"
    }
  }, "\u20B9", showBitDetails === null || showBitDetails === void 0 || (_showBitDetails$payme = showBitDetails.payment_details.find(item => (item === null || item === void 0 ? void 0 : item.payment_method) === "POINTS")) === null || _showBitDetails$payme === void 0 ? void 0 : _showBitDetails$payme.amount)), /*#__PURE__*/React.createElement("div", {
    className: "bit-details-general-columns"
  }, /*#__PURE__*/React.createElement("div", null, "Eligible Transaction Value"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: "500"
    }
  }, "\u20B9", Number(showBitDetails === null || showBitDetails === void 0 ? void 0 : showBitDetails.h_bit_amount) - Number(showBitDetails === null || showBitDetails === void 0 || (_showBitDetails$payme2 = showBitDetails.payment_details.find(item => (item === null || item === void 0 ? void 0 : item.payment_method) === "POINTS")) === null || _showBitDetails$payme2 === void 0 ? void 0 : _showBitDetails$payme2.amount)))) : /*#__PURE__*/React.createElement(React.Fragment, null))), /*#__PURE__*/React.createElement("button", {
    className: "bit-details-done",
    onClick: () => bitDetailsPopupOpen(false, '')
  }, "Done")) : /*#__PURE__*/React.createElement(React.Fragment, null));
};
export { History };